export default class CentroCusto {
    constructor() {
        this.id = null;
        this.codigo = null;
        this.nome = null;
        this.tipo = null;      
        this.gerarCodogioEmSequencia = false;
    }    
}